"use client";

import { ar } from "intl-tel-input/i18n";
import IntlTelInput from "intl-tel-input/react";
import { ComponentProps, useEffect, useState } from "react";

import "intl-tel-input/build/css/intlTelInput.min.css";
import "./styles.css";
import { useTranslation } from "react-i18next";

export interface PhoneValue {
  number: string;
  isValid: boolean;
}

interface Props extends Pick<ComponentProps<typeof IntlTelInput>, "inputProps" | "initialValue"> {
  onChange?: (value: PhoneValue) => void;
  disabled?: boolean;
}

export default function PhoneInput({ onChange, disabled = false, ...props }: Readonly<Props>) {
  const { i18n } = useTranslation();
  const [number, setNumber] = useState("");
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    onChange?.({ number, isValid });
  }, [number, isValid]);

  return (
    <div className="iti-wrapper">
      <IntlTelInput
        onChangeValidity={setIsValid}
        onChangeNumber={setNumber}
        initOptions={{
          initialCountry: "eg",
          excludeCountries: ["il"],
          separateDialCode: true,
          fixDropdownWidth: false,
          i18n: i18n.language === "ar" ? { ...ar, searchPlaceholder: "بحث" } : undefined,
          loadUtils: () =>
            // @ts-expect-error
            import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js"),
        }}
        disabled={disabled}
        {...props}
      />
    </div>
  );
}
